import { Navigate,  useRoutes } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
// import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import Home from "../pages/Home/Home";
import NotFound from "../pages/NotFound";
import Language from "../pages/Language";
import LogIn from "../pages/LogIn";
import About from "../pages/About";
import Team from "../pages/Team";
import Link from "../pages/Link";
import SingleTeam from "../pages/SingleTeam";
import Category from "../pages/Home/Category";
import CategoryBrowser from "../pages/Home/Category/CategoryBrowser";
import Moods from "../pages/Moods";
import PDFView from "../components/home/category/PDFView";
import SubCategDetail from "../pages/Home/Category/Subcategory/SubCategDetail";
import ChildSubCategory from "../pages/Home/Category/Subcategory/ChildSubCategory";
import ForgotNumber from "../pages/ForgotNumber";
import ForgotPin from "../pages/ForgotPin";
import RegisterDelete from "../pages/RegisterDelete";
import PrivcayPolicy from "../pages/PrivcayPolicy";
import OpenImage from "../pages/OpenImage";
import { useSelector } from "react-redux";
import WebLink from "../pages/WebLinks";
import Splash from "../pages/Splash";

export default function AppRouter() {
  const { user } = useSelector((state) => state.Language);

  const RouteElement = useRoutes([
    {
      path: "",
      children: [
        {
          index: true,
          element:
            user == null || user === "Guest User" ? (
              <Navigate to={"/splash"} replace />
            ) : (
              <Navigate to="/home" replace />
            ),
        },
        {
          path: "/home",
          element: <Home />,
        },
        {
          path: "/splash",
          element: <Splash />,
        },
        {
          path: ":category_id",
          children: [
            {
              path: "",
              element: <Category />,
            },
            {
              path: ":subcateg_id",
              children: [
                {
                  path: "",
                  element: <SubCategDetail />,
                },
                {
                  path: ":child_subcateg_id",
                  element: <ChildSubCategory />,
                },
              ],
            },
          ],
        },

        {
          path: ":category-browser",
          element: <CategoryBrowser />,
        },
      ],
    },
    {
      path: "viewPdf",
      element: <PDFView />,
    },
    {
      path: "language",
      element: <Language />,
    },
    {
      path: "login",
      element: <LogIn />,
    },
    {
      path: "about",
      element: <About />,
    },
    {
      path: "team",
      children: [
        {
          path: "",
          element: <Team />,
        },
        {
          path: ":id",
          element: <SingleTeam />,
        },
      ],
    },
    {
      path: "link",
      element: <Link />,
    },
    {
      path: "mood",
      element: <Moods />,
    },
    {
      path: "forgot_number",
      element: <ForgotNumber />,
    },
    {
      path: "forgot_pin",
      element: <ForgotPin />,
    },
    {
      path: "register_delete",
      element: <RegisterDelete />,
    },
    {
      path: "privacy_policy",
      element: <PrivcayPolicy />,
    },
    {
      path: "open_image",
      element: <OpenImage />,
    },
    {
      path: "web_links",
      element: <WebLink />,
    },
    {
      path: "*",
      element: <NotFound />,
    },
  ]);

  const queryClient = new QueryClient();
  return (
    <>
      <QueryClientProvider client={queryClient}>
        {RouteElement}
        {/* <ReactQueryDevtools initialIsOpen={false} /> */}
      </QueryClientProvider>
    </>
  );
}
